// ─── Constants ────────────────────────────────────────────────────────────
const START_HOUR = 8;     // 8 AM
const END_HOUR = 19;      // 7 PM (grid runs 8a–7p)
const HOURS_SHOWN = END_HOUR - START_HOUR;
const PX_PER_HOUR = 60;
const SNAP_MINUTES = 15;
const DEFAULT_DURATION = 60;
const DAY_NAMES_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

// ─── Date helpers ─────────────────────────────────────────────────────────
function startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
function startOfWeek(d) {
  const x = startOfDay(d);
  x.setDate(x.getDate() - x.getDay());
  return x;
}
function startOfMonth(d) {
  const x = startOfDay(d);
  x.setDate(1);
  return x;
}
function addDays(d, n) { const x = new Date(d); x.setDate(x.getDate() + n); return x; }
function addMonths(d, n) { const x = new Date(d); x.setMonth(x.getMonth() + n); return x; }
function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() &&
         a.getMonth() === b.getMonth() &&
         a.getDate() === b.getDate();
}
function formatDayLabel(d) {
  return d.toLocaleDateString(undefined, {
    weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
  });
}
function formatMonthLabel(d) {
  return `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
}
function formatTimeOfDay(d) {
  return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}
function hourLabel(h) {
  if (h === 0) return '12 AM';
  if (h === 12) return '12 PM';
  if (h < 12) return `${h} AM`;
  return `${h - 12} PM`;
}

// Convert Firestore Timestamp | Date | null → Date | null
function toDate(v) {
  if (!v) return null;
  if (v.toDate) return v.toDate();
  if (v instanceof Date) return v;
  return new Date(v);
}

// "10:30" → minutes-from-midnight; "10:30" form values back into Date
function combineDateAndTime(date, hhmm) {
  const [h, m] = hhmm.split(':').map(Number);
  const x = new Date(date);
  x.setHours(h, m, 0, 0);
  return x;
}
function pad2(n) { return String(n).padStart(2, '0'); }
function timeInputValue(d) { return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`; }
function dateInputValue(d) { return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`; }
function dateFromInputValue(s) {
  const [y, m, day] = s.split('-').map(Number);
  return new Date(y, m - 1, day);
}


export { START_HOUR, END_HOUR, HOURS_SHOWN, PX_PER_HOUR, SNAP_MINUTES, DEFAULT_DURATION, DAY_NAMES_SHORT, MONTH_NAMES, startOfDay, startOfWeek, startOfMonth, addDays, addMonths, isSameDay, formatDayLabel, formatMonthLabel, formatTimeOfDay, hourLabel, toDate, combineDateAndTime, pad2, timeInputValue, dateInputValue, dateFromInputValue };
